export const SmallLogo = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.23444"
        y="12.3828"
        width="11.855"
        height="11.855"
        transform="rotate(-45 7.23444 12.3828)"
        fill="url(#paint0_linear_6587_597)"
      />
      <rect
        y="12.3828"
        width="11.855"
        height="11.855"
        transform="rotate(-45 0 12.3828)"
        fill="url(#paint1_linear_6587_597)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6587_597"
          x1="5.42776"
          y1="10.5761"
          x2="24.814"
          y2="29.9624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9051A4" />
          <stop offset="0.118021" stopColor="#CD74EA" />
          <stop offset="0.241612" stopColor="#CD74EA" />
          <stop offset="0.744599" stopColor="#DC9EF0" />
          <stop offset="1" stopColor="#DC9EF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6587_597"
          x1="-10.3732"
          y1="2.00965"
          x2="15.915"
          y2="28.2978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B55A9" />
          <stop offset="0.118021" stopColor="#5579F2" />
          <stop offset="0.197917" stopColor="#5579F2" />
          <stop offset="0.744599" stopColor="#7A93E8" />
          <stop offset="1" stopColor="#88A1F6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
